import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-cognizant-logo',
  imports: [],
  templateUrl: './cognizant-logo.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './cognizant-logo.scss',
})
export class CognizantLogo {

}
